import { Color } from "./base-data";

const colors: Color[][] = [
  ["R", "R", "G", "G", "Y", "Y", "Y", "G", "G", "R", "R", "R", "R", "O", "O"],
  ["O", "R", "R", "B", "B", "G", "Y", "G", "G", "R", "G", "Y", "R", "O", "O"],
  ["B", "O", "O", "B", "G", "G", "G", "R", "O", "G", "G", "G", "G", "G", "Y"],
  ["B", "B", "O", "O", "O", "G", "R", "R", "O", "O", "O", "O", "B", "B", "Y"],
  ["G", "B", "B", "R", "R", "R", "B", "B", "B", "B", "O", "B", "Y", "Y", "G"],
  ["G", "G", "Y", "Y", "R", "B", "B", "Y", "Y", "Y", "B", "B", "O", "Y", "B"],
  ["Y", "Y", "Y", "Y", "R", "O", "O", "O", "R", "Y", "Y", "B", "O", "R", "R"],
];

const stars: boolean[][] = [
  [
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    true,
    false,
    false,
    true,
    false,
    true,
    false,
    false,
    false,
    true,
    false,
    true,
    false,
    false,
    false,
  ],
  [
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    true,
    false,
    false,
    false,
    true,
  ],
  [
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
];

export const board = { colors, stars };
